import { CategoryValueFilter } from 'component/page/search/SortAndFilter/CategoryFilter/CategoryFilter.types';

export const getSelectedTab = (categoryFilter: CategoryValueFilter[]): number => {
    const index = categoryFilter.findIndex((x) => x.selected);
    return index === -1 ? 0 : index;
};
